

export const fechaActual=()=>{
    let fecha = new Date()
    let year = fecha.getFullYear()
    let mes = `${fecha.getMonth() + 1}`
    let dia = `${fecha.getDate()}`    
    if(mes.length == '1'){
        mes = `0${fecha.getMonth() + 1}`
    }else{
        mes = `${fecha.getMonth() + 1}`
    }
    
    if(dia.length == '1'){
        dia = `0${fecha.getDate()}`
    }else{
        dia = `${fecha.getDate()}`
    }
    let fechaCompleta = `${year}-${mes}-${dia}`
    return fechaCompleta
}

export const OtraFormatoDeFechaActual=()=>{
    let fecha = new Date()
    let year = fecha.getFullYear()
    let mes = `${fecha.getMonth() + 1}`
    let dia = `${fecha.getDate()}`    
    if(mes.length == '1'){
        mes = `0${fecha.getMonth() + 1}`
    }else{
        mes = `${fecha.getMonth() + 1}`
    }
    
    if(dia.length == '1'){
        dia = `0${fecha.getDate()}`
    }else{
        dia = `${fecha.getDate()}`
    }
    
    let fechaCompleta = `${year}-${dia}-${mes}`
    return fechaCompleta
}

export const HoraActual =()=>{
    const currentTime = new Date();
    const localizedTime = currentTime.toLocaleString();
    return localizedTime.split(',')[1]
}

export const calcularEdad = (fechaNacimiento)=>{
    let yearNacimiento = new Date(fechaNacimiento)
    let fechaActual = new Date()
    let calcularEdad = fechaActual.getFullYear() - yearNacimiento.getFullYear()
    let totalMes = (fechaActual.getMonth() + 1) - (yearNacimiento.getMonth() + 1)
    let totalDias = fechaActual.getDate() - (yearNacimiento.getDate() + 1)
    let edad= ''
    if(totalMes >= 0 && totalDias >= 0){
        edad=calcularEdad
    }else if(totalMes >= 0){
        edad=calcularEdad
    }else {
        edad=calcularEdad - 1
    }
    return edad
}